module.exports = __webpack_public_path__ + "static/img/3@2x.de14105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/3@2x.png
// module id = wqdx
// module chunks = 0